module.exports = __webpack_public_path__ + "static/media/A37901EC-C108-4CE7-82AB-10AE859E1B6B.3b58ffe5.jpeg";